import { loadScript } from "@/utils";
const hostname = window.location.hostname;
const scripts = [
  "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
  "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8823204853280729",
];
export const useGoogleAdScript = () => {
  if (domains.includes(hostname)) {
    for (let i = 0; i < scripts.length; i++) {
      loadScript(scripts[i], () => {
        console.log("script loaded!" + scripts[i]);
      });
    }
  }
};
export const useGoogleAd = (size: string, index?: any) => {
  let key = hostname;
  const { prefix } = usePrefix();
  if (!domains.includes(hostname)) {
    key = prefix + ".comfortweather.com";
  }
  const advertList = adMap?.[key]?.[size];
  if (isEmptyType(advertList)) {
    return;
  }
  return (advertList || [])[index];
};
